// src/data/initialLookups.js
import { v4 as uuidv4 } from 'uuid';

// Define constants for group codes for easier reference
export const LOOKUP_GROUP_CODES = {
    GENDER: 'GENDER',
    MARITAL_STATUS: 'MARITAL_STATUS',
    IDENTIFICATION_TYPE: 'IDENTIFICATION_TYPE',
    EMPLOYMENT_STATUS: 'EMPLOYMENT_STATUS',
    TASK_STATUS: 'TASK_STATUS',
    INTERACTION_CHANNEL: 'INTERACTION_CHANNEL',
    RELATIONSHIP_TYPE: 'RELATIONSHIP_TYPE',
    // Add more groups as needed (e.g., LOAN_PRODUCT, INDUSTRY_SECTOR)
};

export const initialLookups = {
    [LOOKUP_GROUP_CODES.GENDER]: {
        group_label_en: "Gender",
        group_label_ar: "الجنس",
        isSystem: true, // Core lookup, perhaps prevent deletion
        values: [
            { id: uuidv4(), value: "Male", label_en: "Male", label_ar: "ذكر", isActive: true, order: 1 },
            { id: uuidv4(), value: "Female", label_en: "Female", label_ar: "أنثى", isActive: true, order: 2 },
            { id: uuidv4(), value: "Other", label_en: "Other", label_ar: "آخر", isActive: true, order: 3 }
        ]
    },
    [LOOKUP_GROUP_CODES.MARITAL_STATUS]: {
        group_label_en: "Marital Status",
        group_label_ar: "الحالة الاجتماعية",
        isSystem: true,
        values: [
            { id: uuidv4(), value: "Single", label_en: "Single", label_ar: "أعزب/عزباء", isActive: true, order: 1 },
            { id: uuidv4(), value: "Married", label_en: "Married", label_ar: "متزوج/متزوجة", isActive: true, order: 2 },
            { id: uuidv4(), value: "Divorced", label_en: "Divorced", label_ar: "مطلق/مطلقة", isActive: true, order: 3 },
            { id: uuidv4(), value: "Widowed", label_en: "Widowed", label_ar: "أرمل/أرملة", isActive: true, order: 4 }
        ]
    },
    [LOOKUP_GROUP_CODES.IDENTIFICATION_TYPE]: {
        group_label_en: "Identification Type",
        group_label_ar: "نوع الهوية",
        isSystem: true,
        values: [
            { id: uuidv4(), value: "National ID", label_en: "National ID", label_ar: "الهوية الوطنية", isActive: true, order: 1 },
            { id: uuidv4(), value: "Passport", label_en: "Passport", label_ar: "جواز السفر", isActive: true, order: 2 },
            { id: uuidv4(), value: "Iqama", label_en: "Iqama", label_ar: "إقامة", isActive: true, order: 3 },
            { id: uuidv4(), value: "Driving License", label_en: "Driving License", label_ar: "رخصة قيادة", isActive: true, order: 4 },
            { id: uuidv4(), value: "Business Registration", label_en: "Business Registration", label_ar: "تسجيل تجاري", isActive: true, order: 5 },
            { id: uuidv4(), value: "Commercial Registration", label_en: "Commercial Registration", label_ar: "سجل تجاري", isActive: true, order: 6 }
        ]
    },
    [LOOKUP_GROUP_CODES.EMPLOYMENT_STATUS]: {
        group_label_en: "Employment Status",
        group_label_ar: "الحالة الوظيفية",
        isSystem: true,
        values: [
            { id: uuidv4(), value: "Employed", label_en: "Employed", label_ar: "موظف", isActive: true, order: 1 },
            { id: uuidv4(), value: "Self-employed", label_en: "Self-employed", label_ar: "عمل حر", isActive: true, order: 2 },
            { id: uuidv4(), value: "Unemployed", label_en: "Unemployed", label_ar: "عاطل عن العمل", isActive: true, order: 3 },
            { id: uuidv4(), value: "Retired", label_en: "Retired", label_ar: "متقاعد", isActive: true, order: 4 },
            { id: uuidv4(), value: "Student", label_en: "Student", label_ar: "طالب", isActive: true, order: 5 }
        ]
    },
    [LOOKUP_GROUP_CODES.TASK_STATUS]: {
        group_label_en: "Task Status",
        group_label_ar: "حالة المهمة",
        isSystem: true,
        values: [
            { id: uuidv4(), value: "Pending", label_en: "Pending", label_ar: "قيد الانتظار", isActive: true, order: 1 },
            { id: uuidv4(), value: "InProgress", label_en: "In Progress", label_ar: "قيد التنفيذ", isActive: true, order: 2 },
            { id: uuidv4(), value: "Completed", label_en: "Completed", label_ar: "مكتمل", isActive: true, order: 3 },
            { id: uuidv4(), value: "Overdue", label_en: "Overdue", label_ar: "متأخر", isActive: true, order: 4 },
            { id: uuidv4(), value: "Cancelled", label_en: "Cancelled", label_ar: "ملغى", isActive: true, order: 5 }
        ]
    },
    [LOOKUP_GROUP_CODES.INTERACTION_CHANNEL]: {
        group_label_en: "Interaction Channel",
        group_label_ar: "قناة التفاعل",
        isSystem: true,
        values: [
            { id: uuidv4(), value: "Call", label_en: "Call", label_ar: "مكالمة", isActive: true, order: 1 },
            { id: uuidv4(), value: "Email", label_en: "Email", label_ar: "بريد إلكتروني", isActive: true, order: 2 },
            { id: uuidv4(), value: "SMS", label_en: "SMS", label_ar: "رسالة نصية", isActive: true, order: 3 },
            { id: uuidv4(), value: "WhatsApp", label_en: "WhatsApp", label_ar: "واتساب", isActive: true, order: 4 },
            { id: uuidv4(), value: "Meeting", label_en: "Meeting", label_ar: "اجتماع", isActive: true, order: 5 },
            { id: uuidv4(), value: "System", label_en: "System", label_ar: "النظام", isActive: true, order: 6 },
            { id: uuidv4(), value: "Other", label_en: "Other", label_ar: "أخرى", isActive: true, order: 7 }
        ]
    },
     [LOOKUP_GROUP_CODES.RELATIONSHIP_TYPE]: {
        group_label_en: "Relationship Type",
        group_label_ar: "نوع العلاقة",
        isSystem: false, // Allow users to add/remove relationship types
        values: [
            { id: uuidv4(), value: "Guarantor", label_en: "Guarantor", label_ar: "ضامن", isActive: true, order: 1 },
            { id: uuidv4(), value: "Co-Borrower", label_en: "Co-Borrower", label_ar: "مقترض مشارك", isActive: true, order: 2 },
            { id: uuidv4(), value: "Related Party", label_en: "Related Party", label_ar: "طرف ذو صلة", isActive: true, order: 3 },
        ]
    },
    // Add more groups like INDUSTRY_SECTOR, LOAN_PRODUCT etc. here if needed
};